angular.module('mtic.components.dashboards.teacher_general')
.directive('teacherClassesActive', function ($q, $log, EventManager, TeacherDataService) {
  return {
    templateUrl: 'template.html',
    scope: {
    },
    link: function (scope, element) {
      scope.loadingStatus = {
        done: false,
        error: false
      }
      scope.schools = {
        list: [],
        selected: {}
      }
      scope.classes = {
        list: [],
        new: {
          reset: function(){
            this.name = '';
            this.description = '';
          },
          name: '',
          description: ''
        }
      }
      var eventManager = new EventManager('teacherClassesActive', scope);


      scope.updateClassName = function(classId, name) {
        TeacherDataService.updateClassName(classId, name).then(function(){
          TeacherDataService.getUserClasses(true).then(function(classes){
            scope.classes.list = classes;
            scope.classes.new.reset();
          });
        });
      }

      scope.createClass = function(name, description){
        TeacherDataService.createClass(scope.schools.selected.id, name, description, function(){
          TeacherDataService.getUserClasses(true).then(function(classes){
            scope.classes.list = classes;
            scope.classes.new.reset();
          });
        });
      }

      // init
      scope.teacher = {};
      $q.all([
        TeacherDataService.getUserId(function(user_id){
          scope.teacher.user_id = user_id;
        }),
        TeacherDataService.getUserClasses().then(function(classes){
          scope.classes.list = classes;
        }),
        TeacherDataService.getUserSchools(function(schools){
          scope.schools.list = schools;
          if(!scope.schools.selected){
            scope.schools.selected = scope.schools[0];
          }
        })
      ]).then(function(){
        scope.loadingStatus.done = true;
        scope.loadingStatus.error = false;
      }).catch(function(err){
        $log.error(err);
        scope.loadingStatus.done = true;
        scope.loadingStatus.error = true;
      });

    }
  }
});
